<template>
    <b-container>
        <b-card v-if="wardId!==null">
            <b-breadcrumb>
                <b-breadcrumb-item :to="{name: 'ward-list', params: { wardId: wardId}}">Back to {{ward.ward_name}}</b-breadcrumb-item>
                <b-breadcrumb-item :to="{name: 'ward-bulk-import-list', params: { wardId: wardId}}">Bulk Contact Uploads</b-breadcrumb-item>
                <b-breadcrumb-item active>Load Excel File</b-breadcrumb-item>
            </b-breadcrumb>
            <h1>Ward Name: {{ward.ward_name}}</h1>
        </b-card>
        <b-card>
            <b-row>
                <b-col>
            <b-alert :show="invalidFile" dismissible variant="danger">
            File exceeds 1 MB <b>&rArr;</b>
            </b-alert>  
                </b-col>
            </b-row>
            <b-row>
                <b-col>            
            <p>Spreadsheets must be of type <strong>xlsx</strong> and must have the following
                <ul>
                    <li>Can not be larger than 1 MB</li>
                    <li>Must be less than or equal to 200 contact records max</li>
                    <li>Each row must have <ul>
                            <li>first_name</li>
                            <li>last_name</li>
                            <li>phone_number</li>
                            <li>primary_organization/group has to be one of
                                <ul>
                                    <li>RS - Relief Society</li>
                                    <li>EQ - Elders Quorum</li>
                                    <li>YM - Young Men</li>
                                    <li>YW - Young Women</li>
                                </ul>
                            </li>
                            <li><b>Aux Organization/Group</b> <i>[Optional]</i><br/>
                                Must match an existing aux org/group for the ward.<br/>
                                Must use the org/group code.
                            </li>
                            </ul></li>
                    <li>Can include a header row to identify columns(this row will be skipped)</li>
                </ul>
                <b-table striped :items="table.items"></b-table>
                </p>   
                </b-col>
                <b-col>
                

            <b-form @submit="onSubmit">
            <b-form-group label="Excel File:" label-cols-sm="2">
              <b-form-file 
              required
              id="files" 
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              ref="inputFile"></b-form-file>
            </b-form-group>
            <b-form-checkbox v-model="hasHeaderRow" name="check-button" switch>
            Has Header Row
            </b-form-checkbox>                        
            <b-button type="submit" class="mt-3" variant="primary">Load Spreadsheet</b-button>
            </b-form>
                </b-col>
            </b-row>
        </b-card>
    </b-container>
</template>
<script>
import { WardApi } from "@/app/wards/wardApi";
import handleError from "@/errorHandler";
export default {
    name: "WardImportUtility",
    props: {
        wardId: {
            type: String,
            required: false,
        },
        stakeId: {
            type: String,
            required: false,
        }        
    },
    computed: {},
    data () {
        return {
            ward: {
                ward_id: null,
                stake_id: null,
                ward_name: null,
                ward_city: null,
                twilio_phone_number: null,
                twilio_id: null,
                twilio_password: null,
                twilio_test: false,
                use_ward_org_for_inbound: false,
                send_consent: false
            },
            hasHeaderRow: false,
            invalidFile: false,
            table: {
                id: "sample-data",
                items: [
                    {
                        first_name: 'john',
                        last_name: 'doe',
                        phone_number: '310-555-1234',
                        primary_organization: 'EQ',
                        aux_groups: 'PRIESTS,BISHOPRIC'
                    },
                    {
                        first_name: 'jane',
                        last_name: 'doe',
                        phone_number: '310-555-5678',
                        primary_organization: 'RS',
                        aux_groups: "YSA,WARDCOUNCIL"
                    }                    

                ]
            }


            
        };
    },
    async mounted() {
        if(this.wardId!==null)
            this.ward = await this.getWard();
    },
    methods: {
        async getWard() {
            try{
                const { data } = await WardApi.getWardDetail(this.wardId);
                return data.ward;
            } catch(e) {
                handleError(e, "Error trying to get Ward Information");
            }
        },
        async onSubmit(event) {
            event.preventDefault();
            try{
                this.invalidFile = false;
                let formData = new FormData();
                const theFile = this.$refs.inputFile.files[0];
                if (theFile.size > 1024*1024) {
                    this.invalidFile = true;
                    return;
                }
                formData.append('excel_file', theFile);
                formData.append('file_has_header', this.hasHeaderRow);
                formData.append('original_filename', theFile.name)

                const { data } = await WardApi.uploadContactSpreadsheet(this.wardId, formData)
                //console.log(data);
                this.$router.push({ name: 'ward-bulk-import-list',params: { wardId: this.wardId, stakeId: this.stakeId}});

            } catch (e) {
                handleError(e, "Error trying process bulk contact upload request");
            }
        }        
    }
}
</script>
<style lang="scss" scoped>
</style>